import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
  name: "uniDate",
  standalone: false,
})
export class UniDatePipe implements PipeTransform {
  transform(date: Date | string, format: string = "dd/MM/yyyy"): string {
    date = new Date(date); // if orginal type was a string
    return new DatePipe("en-US").transform(date, format) as string;
  }
}
